import React from 'react';
import { Instagram, Facebook, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#050810] pt-20 pb-10 border-t border-gold/30 relative z-20" data-id="element-19">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16" data-id="element-21">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2" data-id="element-22">
            <a href="#" className="text-gold font-serif text-3xl font-bold tracking-widest block mb-6" data-id="element-23">
              LUMIÈRE{' '}
              <span className="text-pearl font-light text-2xl" data-id="element-24">DENTAL</span>
            </a>
            <p className="font-sans text-pearl/60 text-sm max-w-sm leading-relaxed" data-id="element-25">
              Redefiniendo la odontología moderna a través del arte, la
              tecnología y el confort absoluto. Tu sonrisa es nuestra obra
              maestra.
            </p>
          </div>

          {/* Contact */}
          <div data-id="element-26">
            <h4 className="font-serif text-white text-lg mb-6" data-id="element-27">Contacto</h4>
            <ul className="space-y-4 font-sans text-sm text-pearl/70" data-id="element-28">
              <li className="flex items-start gap-3" data-id="element-29">
                <MapPin size={18} className="text-gold shrink-0 mt-0.5" data-id="element-30" />
                <span data-id="element-31">
                  Av. Libertador 1234, Piso 5<br data-id="element-32" />
                  Buenos Aires, Argentina
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-33">
                <Phone size={18} className="text-gold shrink-0" data-id="element-34" />
                <span data-id="element-35">+54 9 299 519-2151</span>
              </li>
              <li className="flex items-center gap-3" data-id="element-36">
                <Mail size={18} className="text-gold shrink-0" data-id="element-37" />
                <span data-id="element-38">vip@lumieredental.com</span>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div data-id="element-39">
            <h4 className="font-serif text-white text-lg mb-6" data-id="element-40">Síguenos</h4>
            <div className="flex gap-4" data-id="element-41">
              <a href="#" className="w-10 h-10 rounded-full bg-night-800 flex items-center justify-center text-gold hover:bg-gold hover:text-night-900 transition-colors duration-300" data-id="element-42">
                <Instagram size={20} data-id="element-43" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-night-800 flex items-center justify-center text-gold hover:bg-gold hover:text-night-900 transition-colors duration-300" data-id="element-44">
                <Facebook size={20} data-id="element-45" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-night-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-46">
          <p className="font-sans text-xs text-pearl/40" data-id="element-47">
            &copy; {new Date().getFullYear()} Lumière Dental. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6 font-sans text-xs text-pearl/40" data-id="element-48">
            <a href="#" className="hover:text-gold transition-colors" data-id="element-49">
              Políticas de Privacidad
            </a>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-50">
              Términos de Servicio
            </a>
          </div>
        </div>
      </div>
    </footer>;
}